import { render, staticRenderFns } from "./BusquedaDocumentos.vue?vue&type=template&id=04a567c0"
import script from "./BusquedaDocumentos.vue?vue&type=script&lang=js"
export * from "./BusquedaDocumentos.vue?vue&type=script&lang=js"
import style0 from "./BusquedaDocumentos.vue?vue&type=style&index=0&id=04a567c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports